import { useState, useEffect } from 'react'
import useTypewriter from './useTypewriter'
import meImg from './assets/me.PNG'
import meBlinkImg from './assets/meBlink.PNG'
import github from './assets/github.png'
import linkedin from './assets/linkedin.png'
import textbox from './assets/textbox.png'
import resume from './assets/resume.png'
import { Button } from 'react-bootstrap'
import Blink from './blink'
import './App.css'
import './App.jsx'

export default function Welcome({ onStart, onContact }) {
    const firstLine = `Hi, I'm Cam!
    Welcome to my park.`
    const secondLine = `Feel free to explore and
    get to know me along the way.`;
    const thirdLine = `What are you waiting for?`
    const fourthLine = `Tough crowd.`
    const lines = [firstLine, secondLine, thirdLine, fourthLine]
    const [idx, setIdx] = useState(0)
    const [continueTyping, setContinueTyping] = useState(false);

    useEffect(() => {
        if (idx !== 2) {
            setContinueTyping(false)
            return
        }
        const id = setTimeout(() => setContinueTyping(true), 2000)
        return () => clearTimeout(id)
    }, [idx])

    const activeText = idx === 2 ? (continueTyping ? lines[2] : '') : lines[idx]
    const [typed, done] = useTypewriter(activeText, { speedMs: 45, pauseMs: 350 })

    useEffect(() => {
        if (!done) return
        if (!activeText) return

        const id = setTimeout(() => setIdx(i => (i + 1) % lines.length), 700)
        return () => clearTimeout(id)
    }, [done, activeText, lines.length])

    return (
        <div className="welcome-root" style={styles.welcome}>
            <div className="welcome" style={styles.grid}>
                <Blink blinkImg={meBlinkImg} regImg={meImg} style={{ justifySelf: 'left', marginLeft: '15%', bottom: '25%', width: '15%', position: 'fixed' }} />
                <div className="textbox" style={styles.textbox}>
                    <img src={textbox} alt="" className="textbox-img" style={styles.textboxImg} />
                    <p className="text" aria-live="polite" style={styles.text}>
                        {typed}
                        <span className="cursor">{typed.length < lines.length ? '▮' : ''}</span>
                    </p>
                </div>
            </div>
            <Button className="enterBtn" onClick={onStart} aria-label="Enter the park"
                style={styles.enterBtn} onMouseOver={e => {
                    e.currentTarget.style.backgroundColor = '#f4acb7';
                }} onMouseOut={e => {
                    e.currentTarget.style.backgroundColor = '#F6CFD6';
                }}>
                enter
            </Button>
            <div className="footer" style={styles.footer}>
                <Button id="github" style={styles.button} href="https://github.com/camsinfiniteram"
                    onMouseOver={e => { e.currentTarget.style.backgroundColor = '#F6CFD6'; }
                    } onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#f2feffff';
                    }}>
                    <img src={github} alt="GitHub" style={{ width: '100%', height: '100%', display: 'flex' }} />
                </Button>
                <Button id="linkedin" href="https://www.linkedin.com/in/cam-zhu/" style={styles.button}
                    onMouseOver={e => { e.currentTarget.style.backgroundColor = '#F6CFD6'; }} onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#f2feffff';
                    }}>
                    <img src={linkedin} alt="LinkedIn" style={{ width: '100%', height: '100%', display: 'flex' }} />
                </Button>
                <Button id="resume" href="https://drive.google.com/file/d/1kPx5sZarQGinWZ1bftRO19-91blDlsDG/view?usp=sharing" style={styles.button}
                    onMouseOver={e => { e.currentTarget.style.backgroundColor = '#F6CFD6'; }} onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#f2feffff'
                    }}>
                    <img src={resume} alt="Resume" style={{ width: '100%', height: '100%', display: 'flex' }} />
                </Button>
                <Button id="contact" onClick={onContact} style={styles.button}
                    onMouseOver={e => { e.currentTarget.style.backgroundColor = '#F6CFD6'; }} onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#f2feffff'
                    }}>
                    <img src={textbox} alt="contact" style={{ width: '100%', height: '100%', display: 'flex' }} />
                </Button>
            </div>
        </div>

    )
}
const styles = {
    welcome: {
        border: '0.625rem solid #cfeaecff',
        padding: '3.125rem',
        borderRadius: '1.563rem',
        minHeight: '100vh',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        boxSizing: 'border-box',
        backgroundColor: '#fff9faff',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'minmax(7.5rem, auto) 1fr minmax(15rem, auto)',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        gap: 0,
        width: '100%',
        maxWidth: '68.75rem',
    },
    textbox: {
        gridColumn: 1,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'grid',
        objectFit: 'cover',
        position: 'fixed',
        //justifySelf: 'start',
        placeItems: 'center',
        marginLeft: '40%',
        marginBottom: '20%',
        width: '25%',
        height: 'auto'
    },
    textboxImg: {
        position: 'relative',
        objectFit: 'cover',
        zIndex: 0,
        justifyContent: 'center',
        maxWidth: '100%',
    },
    text: {
        position: 'absolute',
        textAlign: 'center',
        zIndex: 1,
        color: '#000000ff',
        lineHeight: '1.2',
        maxWidth: '60%',
        textOverflow: 'ellipsis',
        fontFamily: 'Courier, monospace',
        fontSize: 'clamp(0.25rem, 1vw, 1.5rem)',
    },
    enterBtn: {
        position: 'fixed',
        //justifySelf: 'center',
        bottom: '27%',
        padding: '0.5rem 1rem',
        fontSize: '1rem',
        fontWeight: 'bold',
        marginRight: '50%',
        marginLeft: '50%',
        color: '#000000ff',
        backgroundColor: '#F6CFD6',
        border: 'none',
        borderRadius: 4,
        hover: {
            backgroundColor: '#413C58',
            color: '#ffffffff',
        },
    },
    button: {
        boxSizing: 'border-box',
        width: '1.875rem',
        height: '1.875rem',
        backgroundColor: '#cfeaecff',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0.5rem',
        padding: 4,
    },
    footer: {
        position: 'fixed',
        left: '12.5%',
        bottom: '10%',
        width: '100%',
        display: 'flex',
        gap: 12,
    },

}